export const DEFAULT_EMAIL_BODY_VALUES = {
	backgroundColor: '#FFFFFF',
	contentWidth: '800px',
	fontFamily: {
		label: 'Arial',
		value: 'Arial, Helvetica, sans-serif',
	},
};

//Sets 0 padding for all text blocks...
const textBlockDefaults = {
	fontFamily: {
		editor: {
			defaultValue: { value: 'Arial, Helvetica, sans-serif' },
		},
	},
	padding: {
		editor: {
			defaultValue: [0, 0, 0, 0],
		},
	},
};

export const DEFAULT_EMAIL_TOOL_SETTINGS = {
	tools: {
		bodies: {
			properties: {
				backgroundColor: { editor: { defaultValue: '#FFFFFF' } },
				fontFamily: { editor: { defaultValue: { value: 'Arial, Helvetica, sans-serif' } } },
				contentAlign: { editor: { defaultValue: 'left' } },
			},
		},
		paragraph: {
			properties: {
				...textBlockDefaults,
				fontSize: { editor: { defaultValue: 14 } },
			},
		},
		heading: {
			properties: {
				...textBlockDefaults,
			},
		},
	},
};
